// extracted by mini-css-extract-plugin
export default {"snackbarStyle":"Snackbar_snackbarStyle__wCHJR"};